<template>
  <div class="area-select">
    <el-select v-model="areaSelectInfo.selectProv" :placeholder="$t('areaSelect.province')"
      style="width: 30%; margin-right: 10px" @change="getProv(areaSelectInfo.selectProv)">
      <el-option v-for="item in areaSelectInfo.provs" :key="item.areaCode" :label="item.areaName"
        :value="item.areaCode" />
    </el-select>
    <el-select v-model="areaSelectInfo.selectCity" :placeholder="$t('areaSelect.city')"
      style="width: 30%; margin-right: 10px" :disabled="!areaSelectInfo.selectProv"
      @change="getCity(areaSelectInfo.selectCity)">
      <el-option v-for="item in areaSelectInfo.citys" :key="item.areaCode" :label="item.areaName"
        :value="item.areaCode" />
    </el-select>
    <el-select v-model="areaSelectInfo.selectArea" :placeholder="$t('areaSelect.area')" style="width: 30%"
      :disabled="!areaSelectInfo.selectCity" @change="getArea(areaSelectInfo.selectArea)">
      <el-option v-for="item in areaSelectInfo.areas" :key="item.areaCode" :label="item.areaName"
        :value="item.areaCode" />
    </el-select>
  </div>
</template>

<script>
import { listAreas } from '@/api/community/communityManageApi'

export default {
  name: 'AreaSelect',
  props: {
    callBackListener: {
      type: String,
      default: ''
    },
    callBackFunction: {
      type: String,
      default: ''
    },
    namespace: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      areaSelectInfo: {
        areas: [],
        provs: [],
        citys: [],
        allCity: [],
        selectProv: '',
        selectProvName: '',
        selectCity: '',
        selectCityName: '',
        selectArea: '',
        selectAreaName: ''
      }
    }
  },
  created() {
    this._initArea('101', '0')
  },
  methods: {
    // 根据cityCode设置地区
    async setCityCode(cityCode) {
      if (!cityCode) return
      
      // 鑾峰彇cityCode鐨勯暱搴︽潵鍒ゆ柇鏄渷/甯?鍖
      const codeLength = cityCode.length
      
      if (codeLength >= 2) {
        // 璁剧疆鐪
        const provCode = cityCode.substring(0, 2) + '0000'
        this.areaSelectInfo.selectProv = provCode
        await this._initArea('202', provCode)
      }
      
      if (codeLength >= 4) {
        // 璁剧疆甯
        const cityCodeValue = cityCode.substring(0, 4) + '00'
        this.areaSelectInfo.selectCity = cityCodeValue
        await this._initArea('303', cityCodeValue)
      }
      
      if (codeLength === 6) {
        // 璁剧疆鍖
        this.areaSelectInfo.selectArea = cityCode
      }
      
      this.emitSelectArea()
    },
    getProv(prov) {
      this._initArea('202', prov)
      this.areaSelectInfo.selectCity = ''
      this.areaSelectInfo.selectArea = ''
      this.emitSelectArea()
    },
    getCity(city) {
      this._initArea('303', city)
      this.areaSelectInfo.selectArea = ''
      this.emitSelectArea()
    },
    getArea() {
      this.emitSelectArea()
    },
    emitSelectArea() {
      this.areaSelectInfo.cityCode = this.areaSelectInfo.selectArea || this.areaSelectInfo.selectCity || this.areaSelectInfo.selectProv
      this.areaSelectInfo.areaAddress = ''
      if (!this.areaSelectInfo.provs) return

      this.areaSelectInfo.selectProvName = ''
      this.areaSelectInfo.selectCityName = ''
      this.areaSelectInfo.selectAreaName = ''

      this.areaSelectInfo.provs.forEach(param => {
        if (param.areaCode === this.areaSelectInfo.selectProv) {
          this.areaSelectInfo.selectProvName = param.areaName
        }
      })
      this.areaSelectInfo.citys.forEach(param => {
        if (param.areaCode === this.areaSelectInfo.selectCity) {
          this.areaSelectInfo.selectCityName = param.areaName
        }
      })
      this.areaSelectInfo.areas.forEach(param => {
        if (param.areaCode === this.areaSelectInfo.selectArea) {
          this.areaSelectInfo.selectAreaName = param.areaName
        }
      })

      this.$emit('selectArea', {
        selectProv: this.areaSelectInfo.selectProv,
        selectProvName: this.areaSelectInfo.selectProvName,
        selectCity: this.areaSelectInfo.selectCity,
        selectCityName: this.areaSelectInfo.selectCityName,
        selectArea: this.areaSelectInfo.selectArea,
        selectAreaName: this.areaSelectInfo.selectAreaName
      })
    },
    _initArea(areaLevel, parentAreaCode) {
      return listAreas({ areaLevel, parentAreaCode }).then(res => {
        const tmpAreas = res.areas
        if (areaLevel === '101') {
          this.areaSelectInfo.provs = tmpAreas
        } else if (areaLevel === '202') {
          this.areaSelectInfo.citys = tmpAreas
        } else {
          this.areaSelectInfo.areas = tmpAreas
        }
        return res
      }).catch(error => {
        // eslint-disable-next-line no-console
        console.log('查询地区失败', error)
        this.$message.error(this.$t('areaSelect.fetchError'))
      })
    },
    clearArea() {
      this.areaSelectInfo.selectProv = ''
      this.areaSelectInfo.selectCity = ''
      this.areaSelectInfo.selectArea = ''
    }
  }
}
</script>
